import PropTypes from 'prop-types';
import React from 'react';

import { propTypesNavigation } from '../../Header.proptypes';

import { HeaderMenu } from './HeaderMenu';

import * as S from './WebsiteNavBar.styles';

export const WebsiteNavBar = ({ document, isMobile }) => {
  const {
    menu_1_title: menu1Title,
    menu_2_title: menu2Title,
    menu_3_title: menu3Title,
    menu_4_title: menu4Title,
    menu_1_more_label: menu1MoreLabel,
    menu_2_more_label: menu2MoreLabel,
    menu_3_more_label: menu3MoreLabel,
    menu_4_more_label: menu4MoreLabel,
    menu_1_more_link: { url: menu1MoreUrl, target: menu1MoreTarget } = {},
    menu_2_more_link: { url: menu2MoreUrl, target: menu2MoreTarget } = {},
    menu_3_more_link: { url: menu3MoreUrl, target: menu3MoreTarget } = {},
    menu_4_more_link: { url: menu4MoreUrl, target: menu4MoreTarget } = {},
  } = document || '';

  const {
    menu_1: menu1,
    menu_2: menu2,
    menu_3: menu3,
    menu_4: menu4,
  } = document || {};

  return (
    <S.MenuContainer>
      <HeaderMenu
        isMobile={isMobile}
        moreLabel={menu1MoreLabel}
        moreTarget={menu1MoreTarget}
        moreUrl={menu1MoreUrl}
        sections={menu1}
        title={menu1Title}
      />
      <HeaderMenu
        isMobile={isMobile}
        moreLabel={menu2MoreLabel}
        moreTarget={menu2MoreTarget}
        moreUrl={menu2MoreUrl}
        sections={menu2}
        title={menu2Title}
      />
      <HeaderMenu
        isMobile={isMobile}
        moreLabel={menu3MoreLabel}
        moreTarget={menu3MoreTarget}
        moreUrl={menu3MoreUrl}
        sections={menu3}
        title={menu3Title}
      />
      <HeaderMenu
        isMobile={isMobile}
        moreLabel={menu4MoreLabel}
        moreTarget={menu4MoreTarget}
        moreUrl={menu4MoreUrl}
        sections={menu4}
        title={menu4Title}
      />
    </S.MenuContainer>
  );
};

WebsiteNavBar.propTypes = {
  /**
   * Navigation document from Prismic.
   */
  document: PropTypes.shape(propTypesNavigation.data),
  /**
   * Condition the rendering of DropdownMenu components.
   */
  isMobile: PropTypes.bool,
};
